// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ddd9aab9","522":"f972b84d"}[chunkId] + ".chunk.js";
};